
export const FeatureFlags = Object.freeze({
  PythonApplications: true,
});
